export default "2022-04-20\n# Lancement\nApplication en préparation\n";